import Fingerprint2 from "fingerprintjs2";
import {submitYiiForm} from "../helpers/yii";

export const fingerprint = () => {
    if ( window.variables.fingerprint.active ) {
        setTimeout(() => {
            Fingerprint2.getV18([], ( $hash, components) => {
                submitYiiForm(window.variables.fingerprint.endpoint, {
                    hash: $hash,
                }).then($response => {
                    if ($response.data.data.type === 'premium') {
                        document.body.dataset.fingerprint = 'true';
                    }
                });
            });
        }, 500 );
    }
}

export default {
    bind($item, $bind, $vue) {
        fingerprint();
    }
}
